(function ($) {

  // Alternative products
  $(document).on('click', '[data-show-alternative]', function(event){

    // Get relevant information
    var reference = $(this).data('show-alternative');
    var parent = $(this).parents('.product-block');
    var next = parent.find('[data-alternative-product="' + reference + '"]');
    var active = parent.find('[data-alternative-product].active');
  
    if( !next.length ){
      return;
    }

    // Sort swatchs to always follow the same pattern
    // Will be based on first active alternative
    var wrapper = next.find('.alternatives-wrapper');
    active.find('[data-show-alternative]').each(function(){
      var reference = $(this).data('show-alternative');
      var item = next.find('[data-show-alternative="' + reference + '"]');
      wrapper.append(item);
    });

    // Switch active element
    active.removeClass('active');
    next.addClass('active');
    event.preventDefault();

  });

})(theme.jQuery);  